import { nxExtenManageClient, collectionServiceClient, ticketClient,hrClient} from "@/api/index";

import { OperateNxteleReq, NxteleListReq } from "@/pbjs/xcommon/nxExtenManage_pb";
import { CreatePaymentVoucherReq, UploadDocumentReq } from "@/pbjs/xcommon/collection_pb";  // 提交还款问题上报
import { QuestionParameterReq, ListQuestionParameterReq } from "@/pbjs/xcommon/ticket_pb";  // 提交还款问题上报

import {InnerRequest} from "@/request/requestIndex/utils";

class CommonApi {
  constructor() {

  }
  getRequest(options = {}) {
    return new InnerRequest(
        nxExtenManageClient,
        'nxteleList',
        new NxteleListReq(),
        options
    ).getRequest()
  }
  addName(options = {}) {
    return new InnerRequest(
        nxExtenManageClient,
        'operateNxtele',
        new OperateNxteleReq(),
        options
    ).getRequest()
  }
  reportRepaymentImg(options = {}) {
    console.log(options);
    return new InnerRequest(
        collectionServiceClient,
        'uploadDocument',
        new UploadDocumentReq(),
        options
    ).getRequest()
  }
  reportRepaymentIssue(options = {}) {
    console.log(options);
    return new InnerRequest(
        collectionServiceClient,
        'createPaymentVoucher',
        new CreatePaymentVoucherReq(),
        options
    ).getRequest()
  }

  // 增加问题库参数
  addQuestionFn(options = {}) {
    console.log(options);
    return new InnerRequest(
        ticketClient,
        'saveQuestionParameter',
        new QuestionParameterReq(),
        options
    ).getRequest()
  }
  // 查询问题库参数列表
  queryQuestionListFn(options = {}) {
    console.log(options);
    return new InnerRequest(
        ticketClient,
        'listQuestionParameter',
        new ListQuestionParameterReq(),
        options
    ).getRequest()
  }
  // 删除问题库参数数据
  deleteQuestionDataFn(options = {}) {
    console.log(options);
    return new InnerRequest(
        ticketClient,
        'delQuestionParameter',
        new QuestionParameterReq(),
        options
    ).getRequest()
  }

  //人员需求管理  图片上传
  peopleManagementImg(options = {}) {
    console.log(options);
    return new InnerRequest(
        hrClient,
        'uploadDocument',
        new UploadDocumentReq(),
        options
    ).getRequest()
  }

}



export default {
  commonApi: new CommonApi()
};